export default "__VITE_ASSET__192f4eb8__"